import axios from 'axios';
import { toUpper, trim, isEqual, isObject, isEmpty } from 'lodash';
import moment from 'moment';
import { IOrganization } from '../Interfaces/IOrganization';

const panelUrl = process.env.REACT_APP_PANEL_URL;
export const setButtons = (src: string) => {
  return src.replaceAll('<button>', '<button class="chat-btn">');
};

export const setLinks = (src: string) => {
  const lines = src.toString().split('\n');
  let text = '';
  let index = 0;
  for (const line of lines) {
    let arr = line.split(' ');
    arr = arr.map((e) => {
      return /(http:\/\/)|(www:\/\/)|(https:\/\/)/.test(e)
        ? `<a href="${e}" target="__blank">${e}</a>`
        : e;
    });
    text += arr.join(' ');
    if (index !== lines.length - 1) {
      text += '\n';
    }
    index++;
  }
  return text;
};

export const normaliceGupshupFile = (file: string) => {
  let src = file;
  for (const elem of src.split('"').filter((_, index) => index % 2 !== 0)) {
    src = src.replace(`"${elem}"`, elem.replace(',', '.'));
  }
  return src || '';
};

// returns the html replacing * with <b> tags
export const setB = (src: string) => {
  let close = false;
  return src
    ? src
        .toString()
        .split('')
        .map((e) => {
          if (e !== '*') return e;
          else if (!close) {
            close = !close;
            return '<b>';
          } else {
            close = !close;
            return '</b>';
          }
        })
        .join('')
    : '';
};

// immutable way to insert if not included or else remove
export const arrayInsertRemove = (array: any, value: any) => {
  const index = array.indexOf(value);
  if (index === -1) return [...array, value];
  if (index === 0) {
    return array.slice(1);
  }
  return [...array.slice(0, index), ...array.slice(index + 1)];
};

// returns the beginning and end of a day in moment format
export const getDayRange = (momentDate: moment.Moment) => {
  if (momentDate) {
    const start = moment(momentDate.format('L'), 'L');
    const end = start.clone().add(1, 'day');
    return [start, end];
  }
};

export const verifyOrganization = (organization: IOrganization) => {
  if (!organization || !organization.healthSoftware || !organization.healthSoftware.name)
    return false;
  if (organization.healthSoftware.name === 'macena') {
    return (
      organization.healthSoftware.apiURL &&
      organization.healthSoftware.userName &&
      organization.healthSoftware.password
    );
  } else return false;
};

export const getMonthName = (month: number) => {
  switch (month) {
    case 0:
      return 'Enero';
    case 1:
      return 'Febrero';
    case 2:
      return 'Marzo';
    case 3:
      return 'Abril';
    case 4:
      return 'Mayo';
    case 5:
      return 'Junio';
    case 6:
      return 'Julio';
    case 7:
      return 'Agosto';
    case 8:
      return 'Septiembre';
    case 9:
      return 'Octubre';
    case 10:
      return 'Noviembre';
    case 11:
      return 'Diciembre';
    default:
      return 'Enero';
  }
};

export const keywordType = (keyword: string) => {
  if (keyword.length === 20) return 'ID';
  if (keyword.length <= 9) return 'dni';
  if (keyword.includes('projects/')) return 'session';
  else return 'phone';
};

function removeDiacritics(string: string) {
  if (!string) return '';
  // eslint-disable-next-line no-misleading-character-class
  const regex = /([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi;
  const result = string.trim().toUpperCase().normalize('NFD').replaceAll(regex, '$1').normalize();
  return result;
}

export const standardString = (str: string) => {
  return trim(toUpper(removeDiacritics(str)));
};

export const a11yProps = (index: string) => {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
};

export const getBillingRange = (date: any, initial: any) => {
  if (!date || !initial) return null;
  const tmpDate = moment(date.format('L'), 'L').clone();
  const initialDate =
    initial === 1
      ? tmpDate.clone().set('date', initial)
      : tmpDate.clone().set('date', initial).subtract(1, 'month');
  const endDate = initialDate.clone().add(1, 'month');
  return [initialDate, endDate];
};

export const scaleBilling = (gestiones: number, priceByGestion: number) => {
  const breakpoints = [5000, 3000, 1500];
  let price = 0;
  let count = gestiones;
  let discount = 3;
  for (const breakpoint of breakpoints) {
    if (count > breakpoint) {
      price += (priceByGestion - discount) * (count - breakpoint);
      count = breakpoint;
    }
    discount--;
  }
  price += priceByGestion * count;
  return price;
};

export const getPhraseFormat = (str: string, params: any) => {
  params =
    params &&
    params
      .map((param: any) => ({ ...param, index: str.indexOf(param.value) }))
      .filter((e: any) => e !== -1)
      .sort((a: any, b: any) => (a.index < b.index ? -1 : 1));

  const parts = [];

  if (!params || params[0].index !== 0) {
    const text = str.substring(0, params ? params[0].index : str.length);
    parts.push({ text: `${text}`, entityType: '', alias: '', userDefined: false });
  }
  if (params) {
    params.forEach((param: any, index: number) => {
      parts.push({
        text: param.value,
        entityType: `@${param.entity}`,
        alias: param.entity.toString().toLowerCase(),
        userDefined: true,
      });
      const text = str.substring(
        param.index + param.value.length,
        index !== params.length - 1 ? params[index + 1].index : str.length,
      );
      if (text) {
        parts.push({ text: `${text}`, entityType: '', alias: '', userDefined: true });
      }
    });
  }
  return {
    parts,
    name: '58ba4c54-8ba4-ba4c-2cc5-4c54a68cddc6',
    type: 'EXAMPLE',
    timesAddedCount: 0,
  };
};

export const priceChatsNewModel = (countChats: number, priceByChat: number, disccount: number) => {
  // calcula el total contemplando las escalas
  if (countChats >= 10000) {
    return (
      3000 * priceByChat +
      7000 * (priceByChat - disccount) +
      (countChats - 10000) * (priceByChat - disccount * 2)
    );
  } else if (countChats >= 3000) {
    return 3000 * priceByChat + (countChats - 3000) * (priceByChat - disccount);
  } else {
    return countChats * priceByChat;
  }
};

interface ILogPayload {
  type: string;
  user: any;
  updatedItem: any;
  oldItem: any;
  logContext: any;
}

/**
 * Registra un evento de cambio en el sistema enviando un log con los detalles de la acción realizada.
 * Se utiliza para registrar modificaciones de datos, creaciones o eliminaciones de objetos en el sistema.
 *
 * @param {Object} params - El objeto con los parámetros para el registro del log.
 * @param {string} params.type - El tipo de evento que se está registrando, generalmente hace referencia a la colección o subcolección que se está modificando.
 * @param {Object} params.user - Información sobre el usuario que realiza la acción, como su correo electrónico o ID de usuario.
 * @param {Object} params.updatedItem - El objeto que contiene los nuevos datos después de la modificación (en caso de ser una actualización o creación).
 * @param {Object} [params.oldItem={}] - El objeto que contiene los datos anteriores a la modificación (solo necesario en caso de actualización).
 * @param {Object} params.logContext - Contexto del log que incluye detalles específicos de la operación:
 *   @param {string} params.logContext.collection - El nombre de la colección de Firestore donde se realizó el cambio.
 *   @param {string} params.logContext.docId - El ID del documento de Firestore que se modificó.
 *   @param {string} params.logContext.action - El tipo de acción realizada, por ejemplo, 'create', 'update' o 'delete'.
 *  Se pueden adicionar mas items en caso de actualizar una subcollection. 
 *
 * @description
 * Si la acción es una **creación**, no es necesario enviar `oldItem` ya que no existía previamente.
 * Si la acción es una **eliminación**, no se debe enviar `updatedItem` ya que el objeto ha sido eliminado.
 *
 * @returns {Promise<void>} - No retorna valor, solo registra el log en el sistema.
 
 */
export const panelLogEvent = async ({
  type,
  user,
  updatedItem,
  oldItem = {},
  logContext,
}: ILogPayload): Promise<void> => {
  try {
    const content = isEmpty(oldItem) ? updatedItem : getDifferences(oldItem, updatedItem);

    const response = await axios(`${panelUrl}/event-logs`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: JSON.stringify({ type, user, content, logContext }),
    });

    if (!response.status) {
      throw new Error('Error al registrar el log');
    }
  } catch (error) {
    console.error('Error enviando log: ', error);
  }
};

interface Difference {
  path: string;
  from: any;
  to: any;
}

export const getDifferences = (obj1: any, obj2: any, path = ''): Difference[] => {
  let differences: Difference[] = [];

  try {
    if (Array.isArray(obj1) && Array.isArray(obj2)) {
      const maxLength = Math.max(obj1.length, obj2.length);

      for (let i = 0; i < maxLength; i++) {
        const newPath = `${path}[${i}]`;

        if (i >= obj1.length) {
          // Elemento agregado en obj2
          differences.push({ path: newPath, from: 'undefined', to: obj2[i] });
        } else if (i >= obj2.length) {
          // Elemento eliminado en obj2
          differences.push({ path: newPath, from: obj1[i], to: 'undefined' });
        } else if (!isEqual(obj1[i], obj2[i])) {
          if (isObject(obj1[i]) && isObject(obj2[i])) {
            differences = differences.concat(getDifferences(obj1[i], obj2[i], newPath));
          } else {
            differences.push({ path: newPath, from: obj1[i], to: obj2[i] });
          }
        }
      }
      return differences;
    }

    const keys = new Set([...Object.keys(obj1 || {}), ...Object.keys(obj2 || {})]);

    keys.forEach((key) => {
      const newPath = path ? `${path}.${key}` : key;

      if (isObject(obj1[key]) && isObject(obj2[key])) {
        differences = differences.concat(getDifferences(obj1[key], obj2[key], newPath));
      } else if (!isEqual(obj1[key], obj2[key])) {
        differences.push({ path: newPath, from: obj1[key], to: obj2[key] });
      }
    });

    return differences;
  } catch (error) {
    console.error('getDifferences:', error);
    if (isEmpty(obj2)) {
      return [{ path: 'Se ha borrado el documento', from: obj1, to: obj2 }];
    }
    return [{ path: 'No se pudo obtener el dato especifico a actualizar', from: obj1, to: obj2 }];
  }
};
